import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "wasp/client/operations";
import { getLocationBySlug } from "wasp/client/operations";
import LocationReceptionPage from "../reception/LocationReceptionPage";
import LoadingSpinner from "../../admin/layout/LoadingSpinner";
import { DashboardLayout } from "../../client/components/Sidebar";

export default function LocationDashboardPage() {
  const { slug } = useParams<{ slug: string }>();
  const { data: location, isLoading, error } = useQuery(getLocationBySlug, { slug: slug! });

  if (isLoading) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center min-h-screen">
          <LoadingSpinner />
        </div>
      </DashboardLayout>
    );
  }

  if (error || !location) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-red-600">Error Loading Location</h1>
            <p className="text-muted-foreground">{error?.message || "Location not found"}</p>
          </div>
        </div>
      </DashboardLayout>
    );
  }

  return <LocationReceptionPage location={location as any} />;
}
